import { gql } from '@apollo/client';

export const RETURN_TOOL_BOOKING = gql`
  mutation ReturnToolBooking($id: ID!, $message: String) {
    returnToolBooking(input: { id: $id, message: $message }) {
      toolBooking {
        id
        status
        fromDate
        toDate
      }
      errors
    }
  }
`;

export const RETURN_TOOL_BOOKING_DIRECT = gql`
  mutation ReturnToolBookingDirect($id: ID!, $message: String) {
    returnToolBooking(id: $id, message: $message) {
      toolBooking {
        id
        status
        fromDate
        toDate
      }
      errors
    }
  }
`;

export const COMPLETE_TOOL_BOOKING = gql`
  mutation CompleteToolBooking($id: ID!, $message: String) {
    completeToolBooking(input: { id: $id, message: $message }) {
      toolBooking {
        id
        status
        fromDate
        toDate
      }
      errors
    }
  }
`;

export const COMPLETE_TOOL_BOOKING_DIRECT = gql`
  mutation CompleteToolBookingDirect($id: ID!, $message: String) {
    completeToolBooking(id: $id, message: $message) {
      toolBooking {
        id
        status
        fromDate
        toDate
      }
      errors
    }
  }
`;

export const RETURN_TOOL_BOOKING_WITH_DAMAGES = gql`
  mutation ToolReturnedWithDamages($id: ID!, $comment: String!, $attachments: [AttachmentInputType!]!) {
    toolReturnedWithDamages(input: { id: $id, comment: $comment, attachments: $attachments }) {
      toolBooking {
        id
        status
      }
      errors
    }
  }
`;
